import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
/**
 * Tabs.
 *
 * @param {TabsProps} props tabs's props
 * @returns {React.FC<TabsProps>} Tabs.
 */
export var CustomTabs = function (options) {
    var tabHeaders = options.tabHeaders, tabPanels = options.tabPanels, value = options.value, handleChange = options.handleChange;
    return (React.createElement(React.Fragment, null,
        React.createElement(Tabs, { value: value, onChange: handleChange, textColor: 'primary', indicatorColor: 'primary', variant: 'fullWidth' }, tabHeaders.map(function (tabHeader) { return (React.createElement(Tab, { key: tabHeader.index, label: tabHeader.label })); })),
        tabPanels.map(function (tabPanel) { return (React.createElement("div", { key: tabPanel.index, role: 'tabpanel', hidden: value !== tabPanel.index, id: "tabpanel-" + tabPanel.index }, tabPanel.content)); })));
};
//# sourceMappingURL=CustomTabs.js.map